import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { CountdownComponent } from 'countdown';

@Component({
  selector: 'lib-promotion-banner',
  templateUrl: './promotion-banner.component.html',
  styleUrls: ['./promotion-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, CountdownComponent],
})
export class PromotionBannerComponent {
  public isOffer = input(false);
  public text = input('');
  public countdownDate = input<string>();
  public countdownIsOver = signal(false);
  public showCountDown = computed(
    () => new Date(this.countdownDate()).getTime() - new Date().getTime() > 0 && !this.countdownIsOver()
  );

  public get shortText() {
    return this.text()?.replace(/<\/?[^>]+(>|$)/g, '');
  }
}
